import React from "react";

export const PrintFooter = () => (
  <div className="print-footer" style={{
    textAlign: "center",
    fontSize: "0.85rem",
    color: "#555",
    borderTop: "1px solid #ccc",
    paddingTop: "8px",
    paddingBottom: "8px",
    marginTop: "15px"
  }}>
    This is a system generated print no signature required, <strong>NOT VALID FOR COURT</strong>
  </div>
);

export const printFooterStyles = `
  .master-print-table {
    width: 100% !important;
    border-collapse: collapse !important;
    border: none !important;
  }
  .master-print-table > tbody > tr > td,
  .master-print-table > tfoot > tr > td {
    border: none !important;
    padding: 0 !important;
  }
  .print-footer {
    text-align: center !important;
    font-size: 0.85rem !important;
    color: #555 !important;
    border-top: 1px solid #ccc !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    margin-top: 15px !important;
  }
  @page {
    margin: 10mm !important;
  }
`;

export default function PrintWrapper({ children }) {
  return (
    <table className="master-print-table" style={{ width: "100%", borderCollapse: "collapse", border: "none" }}>
      <tbody>
        <tr>
          <td style={{ border: "none", padding: 0 }}>{children}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td style={{ border: "none", padding: 0 }}>
            <PrintFooter />
          </td>
        </tr>
      </tfoot>
    </table>
  );
}
